import React, { Children } from 'react';
import { motion } from 'framer-motion';
const GOLD = '#d8b878';
export function TableOfContents() {
  const chapters = ['La máscara del yo', 'El alma como jugador', 'El origen y la Fuente', 'El espejismo del tiempo', 'Los personajes del juego', 'El sistema y sus reglas', 'Entidades y dimensiones', 'El espejo de las relaciones', 'La gran ilusión', 'Contratos y ataduras', 'El secreto del miedo', 'El arte de jugar despiertos', 'DMT y la realidad simulada'];
  return <section className="relative overflow-hidden bg-matrix-black py-16 md:py-24 px-4 border-t border-matrix-green/10" data-id="element-321">
      {/* Subtle digital board texture + depth */}
      <div className="pointer-events-none absolute inset-0 z-0 opacity-[0.04]" style={{
      backgroundImage: 'repeating-linear-gradient(0deg, rgba(0,255,65,0.5) 0px, rgba(0,255,65,0.5) 1px, transparent 1px, transparent 26px), repeating-linear-gradient(90deg, rgba(216,184,120,0.4) 0px, rgba(216,184,120,0.4) 1px, transparent 1px, transparent 26px)',
      maskImage: 'radial-gradient(ellipse at center, black 18%, transparent 80%)',
      WebkitMaskImage: 'radial-gradient(ellipse at center, black 18%, transparent 80%)'
    }} data-id="element-322"></div>
      <div className="pointer-events-none absolute inset-0 z-0 bg-[radial-gradient(ellipse_at_center,_rgba(216,184,120,0.05)_0%,_transparent_55%)]" data-id="element-323"></div>
      {/* Soft transition in from the previous section */}
      <div className="pointer-events-none absolute inset-x-0 top-0 z-0 h-24 bg-gradient-to-b from-matrix-black to-transparent" data-id="element-324"></div>

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-325">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-10 md:mb-14" data-id="element-326">
          <span className="inline-block font-inter text-[10px] md:text-xs tracking-[0.4em] uppercase mb-5" style={{
          color: 'rgba(216,184,120,0.7)'
        }} data-id="element-327">
            El recorrido
          </span>
          <h2 className="font-cinzel text-2xl md:text-4xl lg:text-5xl text-matrix-cream mb-4 md:mb-5 drop-shadow-[0_0_10px_rgba(245,230,200,0.1)] tracking-wide" data-id="element-328">
            DENTRO DEL EBOOK PRINCIPAL ENCONTRARÁS
          </h2>
          <div className="w-14 h-[2px] bg-matrix-green/50 mx-auto mb-5 md:mb-6 rounded-full" data-id="element-329"></div>
          <p className="text-sm md:text-base text-matrix-white/75 font-light leading-relaxed max-w-xl mx-auto" data-id="element-330">
            13 capítulos + epílogo diseñados para ayudarte a cuestionar
            patrones, creencias y la manera en que interpretas tu realidad.
          </p>
        </motion.div>

        {/* Pathway */}
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} variants={{
        hidden: {},
        visible: {
          transition: {
            staggerChildren: 0.06
          }
        }
      }} className="relative pl-12 md:pl-16" data-id="element-331">
          {/* Connecting line of the journey */}
          <div className="pointer-events-none absolute left-[19px] md:left-[27px] top-2 bottom-10 w-px bg-gradient-to-b from-matrix-green/40 via-[rgba(216,184,120,0.35)] to-[rgba(216,184,120,0.6)]" data-id="element-332"></div>

          {chapters.map((title, index) => <motion.div key={index} variants={{
          hidden: {
            opacity: 0,
            x: -12
          },
          visible: {
            opacity: 1,
            x: 0,
            transition: {
              duration: 0.45
            }
          }
        }} className="relative mb-3 md:mb-4" data-id="element-333">
              {/* Node on the line */}
              <span className="absolute -left-12 md:-left-16 top-1/2 -translate-y-1/2 flex h-10 w-10 md:h-[3.25rem] md:w-[3.25rem] items-center justify-center rounded-full border border-matrix-green/30 bg-matrix-black font-cinzel text-xs md:text-sm tabular-nums text-matrix-green/90 shadow-[0_0_18px_-4px_rgba(0,255,65,0.4)]" data-id="element-334">
                {String(index + 1).padStart(2, '0')}
              </span>

              {/* Level card / door */}
              <div className="group flex items-center gap-3 rounded-lg border border-matrix-green/15 bg-matrix-dark/50 backdrop-blur-sm px-4 md:px-5 py-3 md:py-3.5 transition-all duration-300 hover:border-[rgba(216,184,120,0.4)] hover:bg-matrix-dark/70 hover:translate-x-1" data-id="element-335">
                <span className="h-4 w-px bg-matrix-green/30 shrink-0 group-hover:bg-[rgba(216,184,120,0.5)] transition-colors" data-id="element-336"></span>
                <span className="text-matrix-white text-sm md:text-base font-light leading-snug" data-id="element-337">
                  {title}
                </span>
              </div>
            </motion.div>)}

          {/* Epilogue — the gate that closes the journey */}
          <motion.div variants={{
          hidden: {
            opacity: 0,
            x: -12
          },
          visible: {
            opacity: 1,
            x: 0,
            transition: {
              duration: 0.45
            }
          }
        }} className="relative mt-5 md:mt-6" data-id="element-338">
            <span className="absolute -left-12 md:-left-16 top-1/2 -translate-y-1/2 flex h-10 w-10 md:h-[3.25rem] md:w-[3.25rem] items-center justify-center rounded-full border bg-matrix-black text-base md:text-lg shadow-[0_0_24px_-2px_rgba(216,184,120,0.6)]" style={{
            borderColor: 'rgba(216,184,120,0.55)',
            color: GOLD
          }} data-id="element-339">
              ✦
            </span>
            <div className="rounded-lg border bg-[rgba(216,184,120,0.05)] backdrop-blur-sm px-5 py-4 md:py-5" style={{
            borderColor: 'rgba(216,184,120,0.35)'
          }} data-id="element-340">
              <span className="block font-inter text-[10px] tracking-[0.3em] uppercase mb-1.5" style={{
              color: 'rgba(216,184,120,0.7)'
            }} data-id="element-341">
                Epílogo
              </span>
              <span className="font-cinzel italic text-base md:text-lg text-matrix-cream" style={{
              textShadow: '0 0 22px rgba(216,184,120,0.3)'
            }} data-id="element-342">
                El verdadero juego
              </span>
            </div>
          </motion.div>
        </motion.div>

        {/* Bonus bridge */}
        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.25
      }} className="text-center mt-10 md:mt-14 text-[14px] md:text-base text-matrix-cream/90 font-light leading-relaxed max-w-xl mx-auto px-2" data-id="element-343">
          Y para llevar esta lectura a tu propia vida, también recibirás el{' '}
          <span style={{
          color: GOLD
        }} data-id="element-344">
            Cuaderno de Reflexión: Despierta el Juego.
          </span>
        </motion.p>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.35
      }} className="text-center mt-5 md:mt-6 text-matrix-white/55 text-xs md:text-sm font-light italic leading-relaxed max-w-lg mx-auto px-2" data-id="element-345">
          Una lectura estructurada para ayudarte a observar tu realidad con más
          claridad, conciencia y dirección.
        </motion.p>
      </div>
    </section>;
}